<template>
  <div class="czjl_wrap">
    <div class="czjl_list">
      <div
        class="czjl_item"
        v-for="(item, index) in czjlList.rows"
        :key="index"
      >
        <div class="stock">{{ item.stockName }}/{{ item.stockCode }}</div>

        <div class="time">{{ item.eventTime }}</div>

        <div class="type">
          {{
            item.eventType == 0
              ? "买入"
              : item.eventType == 2 || item.eventType == 3
              ? "卖出"
              : item.eventType == 4
              ? "调整止盈止损"
              : ""
          }}
        </div>

        <div class="price">
          {{
            item.eventType == 0
              ? `建议买入价格：${COMMON.formatToFixed(item.buyPrice)}`
              : item.eventType == 2 || item.eventType == 3
              ? `建议卖出价格：${COMMON.formatToFixed(item.sellPrice)}`
              : item.eventType == 4
              ? `入选时买入价格：${COMMON.formatToFixed(item.buyPrice)}`
              : ""
          }}
        </div>

        <div class="zyzs_box">
          <div class="zyzs" v-if="item.eventType == 0">
            <div>止盈：{{ COMMON.formatToFixed(item.stopProfitPrice) }}</div>

            <div>止损：{{ COMMON.formatToFixed(item.stopLossPrice) }}</div>
          </div>

          <div
            class="zyzs"
            v-else-if="item.eventType == 2 || item.eventType == 3"
          >
            {{
              [2, 3].includes(item.eventType)
                ? `已达${item.eventType == 2 ? "止盈" : "止损"}`
                : ""
            }}
          </div>

          <div class="zyzs" v-else-if="item.eventType == 4">
            <div>
              止盈：{{ COMMON.formatToFixed(item.beforeStopProfitPrice) }} →
              {{
                item.stopProfitPrice == item.beforeStopProfitPrice
                  ? ""
                  : item.stopProfitPrice > item.beforeStopProfitPrice
                  ? "↑"
                  : "↓"
              }}{{ COMMON.formatToFixed(item.stopProfitPrice) }}
            </div>

            <div>
              止损：{{ COMMON.formatToFixed(item.beforeStopLossPrice) }} →
              {{
                item.stopLossPrice == item.beforeStopLossPrice
                  ? ""
                  : item.stopLossPrice > item.beforeStopLossPrice
                  ? "↑"
                  : "↓"
              }}{{ COMMON.formatToFixed(item.stopLossPrice) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination_box">
      <el-pagination
        size="small"
        background
        v-model:current-page="pageNum"
        v-model:page-size="pageSize"
        layout="prev, pager, next"
        :total="czjlList.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoList: {},
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 12,
      czjlList: {},
    };
  },
  created() {
    this.getOperationList(); // 获取 操作记录 list
  },
  mounted() {},
  methods: {
    // 获取 操作记录 list
    getOperationList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        strategyId: this.infoList.id,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/operation-record", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data;
          // console.log(datas);

          if (datas) {
            this.czjlList = datas;
          }
        }
      );
    },

    // 分页 页码切换
    handleCurrentChange() {
      this.getOperationList(); // 获取 操作记录 list

      this.$emit("smoothFixedHeight"); // 父页面 平滑 滚到到顶部
    },
  },
};
</script>

<style lang="less" scoped>
.czjl_wrap {
  .czjl_list {
    min-height: 500px;
    font-size: 14px;

    .czjl_item {
      display: flex;
      margin-top: 36px;

      .stock {
        width: 125px;
      }

      .time {
        margin-left: 24px;
      }

      .type {
        width: 100px;
        text-align: center;
        margin-left: 24px;
      }

      .price {
        width: 181px;
        margin-left: 24px;
      }

      .zyzs_box {
        margin-left: 24px;

        .zyzs {
          display: flex;

          div {
            margin-left: 24px;

            &:first-child {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .pagination_box {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>